import { newsletterService } from "../services/newsletter.service";
import { validateEmail } from "../../auth/helpers";
import { feedbackService } from "../services/userMessage.service";
import { authService } from "../../auth/services/auth.service";
import { i18n } from "../../core/services/i18n.service";
export class NewsletterForm {
    private formTemplate: string;
    private frenchId: string;
    private englishId: string;

    private formId = "newsletter-form";
    private emailId = "form-email";
    private languageId = "form-language";

    constructor(formTemplate: string, frenchId: string, englishId: string) {
        this.formTemplate = formTemplate;
        this.frenchId = frenchId;
        this.englishId = englishId;
    }

    public initialize(): void {
        const newsletterFormDiv = document.getElementById("newsletter-form-container");
        if (!newsletterFormDiv) {
            throw new Error("Newsletter form div not found");
        }
        newsletterFormDiv.innerHTML = this.formTemplate;
        newsletterFormDiv.addEventListener("submit", (event) => {
            event.preventDefault();
            this.handleSubmit();
        });
    }

    public setEmailInputValue(email: string): void {
        const emailSelector = document.querySelector(`#${this.emailId}`) as HTMLInputElement;
        emailSelector.value = email;
        emailSelector.disabled = true;
        emailSelector.style.cursor = "not-allowed";
    }

    private async handleSubmit(): Promise<void> {
        feedbackService.hideMessages();
        feedbackService.setSubmitButtonLoading(true);

        try {
            const form: HTMLFormElement = document.querySelector(`#${this.formId}`);
            if (!form) {
                const errorMessage = i18n.getLanguage() === "fr" ? "Formulaire non trouvé" : "Form not found";
                throw new Error(errorMessage);
            }

            const emailSelector = form.querySelector(`#${this.emailId}`) as HTMLInputElement;
            const languageSelector = form.querySelector(`#${this.languageId}`) as HTMLInputElement;

            if (validateEmail(emailSelector.value) === false) {
                const errorMessage = i18n.getLanguage() === "fr" ? "Veuillez entrer une adresse email valide" : "Please enter a valid email address";
                throw new Error(errorMessage);
            }

            const email = emailSelector.value;
            const language = languageSelector.value;

            const id = language === "french" ? this.frenchId : this.englishId;
            if (!id) {
                const errorMessage = i18n.getLanguage() === "fr" ? "Veuillez sélectionner une langue" : "Please select a language";
                throw new Error(errorMessage);
            }

            const response = await newsletterService.subscribe(email, id);
            if (response instanceof Error) {
                const errorMessage = i18n.getLanguage() === "fr" ? "Une erreur est survenue lors de l'abonnement à la newsletter" : "An error occurred while subscribing to the newsletter";
                throw new Error(errorMessage);
            }

            const successMessage = i18n.getLanguage() === "fr" ? "Succès ! Vous êtes abonné à la newsletter" : "Success ! You are subscribed to the newsletter";
            feedbackService.showSuccessMessage(
                authService.isAuthenticated ? successMessage : successMessage
            );
            if (authService.isAuthenticated) {
                feedbackService.reloadPage();
            }
            return response
        }
        catch (error) {
            feedbackService.showErrorMessage(error.message);
        }
        finally {
            feedbackService.setSubmitButtonLoading(false);
        }
    }
} 